"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = exports.GOGO_ICON = exports.COMBINATION_OFFER_ICON = exports.DISCOUNT_ICON = exports.SHIPPING_ICON = exports.TAG_ICON = exports.MASTERCARD_ICON = exports.APPLEPAY_ICON = exports.PAYPAL_ICON = exports.CREDITCARD_ICON = exports.MINUS_LIGHT = exports.PLUS_LIGHT = exports.INFO_ICON = exports.MINUS = exports.PLUS = exports.CLOCK = exports.CALENDAR = exports.UNDO_ICON = exports.XICON = exports.WARNING_ICON = exports.SUCCESS_ICON = exports.VALID_ICON = exports.CARET_UP = exports.CARET_DOWN = exports.CARET_LEFT = exports.CARET_RIGHT = exports.CIRCLE_EMPTY_ICON = exports.CHECK_SELECTED = exports.ADD_PHOTO = exports.ERROR_ICON = exports.KEYBOARD_RIGHT = exports.LARGE_CHEVRON_RIGHT = exports.CHEVRON_RIGHT = exports.LARGE_CHEVRON_LEFT = exports.CHEVRON_LEFT = exports.CHEVRON_UP = exports.CHEVRON_DOWN = exports.CART_ICON = exports.TAG = exports.MASTERPASS = exports.APPLEPAY = exports.PAYPAL = exports.CREDITCARD = exports.INFO = exports.SUCCESS = exports.WARNING = exports.VALID = exports.ERROR = exports.a11yHide = void 0;

var _react = _interopRequireDefault(require("react"));

var _check = _interopRequireDefault(require("react-icons/lib/fa/check"));

var _exclamationTriangle = _interopRequireDefault(require("react-icons/lib/fa/exclamation-triangle"));

var _close = _interopRequireDefault(require("react-icons/lib/fa/close"));

var _caretRight = _interopRequireDefault(require("react-icons/lib/fa/caret-right"));

var _caretLeft = _interopRequireDefault(require("react-icons/lib/fa/caret-left"));

var _caretDown = _interopRequireDefault(require("react-icons/lib/fa/caret-down"));

var _caretUp = _interopRequireDefault(require("react-icons/lib/fa/caret-up"));

var _circleThin = _interopRequireDefault(require("react-icons/lib/fa/circle-thin"));

var _calendar = _interopRequireDefault(require("react-icons/lib/fa/calendar"));

var _clockO = _interopRequireDefault(require("react-icons/lib/fa/clock-o"));

var _plus = _interopRequireDefault(require("react-icons/lib/fa/plus"));

var _minus = _interopRequireDefault(require("react-icons/lib/fa/minus"));

var _exclamationCircle = _interopRequireDefault(require("react-icons/lib/fa/exclamation-circle"));

var _chevronRight = _interopRequireDefault(require("react-icons/lib/fa/chevron-right"));

var _chevronLeft = _interopRequireDefault(require("react-icons/lib/fa/chevron-left"));

var _creditCard = _interopRequireDefault(require("react-icons/lib/fa/credit-card"));

var _apple = _interopRequireDefault(require("react-icons/lib/fa/apple"));

var _ccMastercard = _interopRequireDefault(require("react-icons/lib/fa/cc-mastercard"));

var _paypal = _interopRequireDefault(require("react-icons/lib/fa/paypal"));

var _shoppingCart = _interopRequireDefault(require("react-icons/lib/ti/shopping-cart"));

var _minus2 = _interopRequireDefault(require("react-icons/lib/io/minus"));

var _plus2 = _interopRequireDefault(require("react-icons/lib/io/plus"));

var _replay = _interopRequireDefault(require("react-icons/lib/md/replay"));

var _reportProblem = _interopRequireDefault(require("react-icons/lib/md/report-problem"));

var _expandMore = _interopRequireDefault(require("react-icons/lib/md/expand-more"));

var _expandLess = _interopRequireDefault(require("react-icons/lib/md/expand-less"));

var _chevronLeft2 = _interopRequireDefault(require("react-icons/lib/md/chevron-left"));

var _chevronRight2 = _interopRequireDefault(require("react-icons/lib/md/chevron-right"));

var _addAPhoto = _interopRequireDefault(require("react-icons/lib/md/add-a-photo"));

var _keyboardArrowRight = _interopRequireDefault(require("react-icons/lib/md/keyboard-arrow-right"));

var _BiColorCheck = require("./BiColorCheck");

var _TagIcon = require("./TagIcon");

var _nudgeIcon = require("./nudgeIcon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var a11yHide = {
  focusable: 'false',
  'aria-hidden': 'true'
};
exports.a11yHide = a11yHide;
var ERROR = 'error';
exports.ERROR = ERROR;
var VALID = 'valid';
exports.VALID = VALID;
var WARNING = 'warning';
exports.WARNING = WARNING;
var SUCCESS = 'success';
exports.SUCCESS = SUCCESS;
var INFO = 'info';
exports.INFO = INFO;
var CREDITCARD = 'credit-card';
exports.CREDITCARD = CREDITCARD;
var PAYPAL = 'paypal';
exports.PAYPAL = PAYPAL;
var APPLEPAY = 'applePay';
exports.APPLEPAY = APPLEPAY;
var MASTERPASS = 'masterPass';
exports.MASTERPASS = MASTERPASS;
var TAG = 'tag';
exports.TAG = TAG;

var CART_ICON = _react.default.createElement(_shoppingCart.default, a11yHide);

exports.CART_ICON = CART_ICON;

var CHEVRON_DOWN = _react.default.createElement(_expandMore.default, a11yHide);

exports.CHEVRON_DOWN = CHEVRON_DOWN;

var CHEVRON_UP = _react.default.createElement(_expandLess.default, a11yHide);

exports.CHEVRON_UP = CHEVRON_UP;

var CHEVRON_LEFT = _react.default.createElement(_chevronLeft2.default, a11yHide);

exports.CHEVRON_LEFT = CHEVRON_LEFT;

var LARGE_CHEVRON_LEFT = _react.default.createElement(_chevronLeft.default, a11yHide);

exports.LARGE_CHEVRON_LEFT = LARGE_CHEVRON_LEFT;

var CHEVRON_RIGHT = _react.default.createElement(_chevronRight2.default, a11yHide);

exports.CHEVRON_RIGHT = CHEVRON_RIGHT;

var LARGE_CHEVRON_RIGHT = _react.default.createElement(_chevronRight.default, a11yHide);

exports.LARGE_CHEVRON_RIGHT = LARGE_CHEVRON_RIGHT;

var KEYBOARD_RIGHT = _react.default.createElement(_keyboardArrowRight.default, a11yHide);

exports.KEYBOARD_RIGHT = KEYBOARD_RIGHT;

var ERROR_ICON = _react.default.createElement(_reportProblem.default, a11yHide);

exports.ERROR_ICON = ERROR_ICON;

var ADD_PHOTO = _react.default.createElement(_addAPhoto.default, a11yHide);

exports.ADD_PHOTO = ADD_PHOTO;

var CHECK_SELECTED = _react.default.createElement(_BiColorCheck.BiColorCheck, a11yHide); // ADA is inline


exports.CHECK_SELECTED = CHECK_SELECTED;

var CIRCLE_EMPTY_ICON = _react.default.createElement(_circleThin.default, a11yHide);

exports.CIRCLE_EMPTY_ICON = CIRCLE_EMPTY_ICON;

var CARET_RIGHT = _react.default.createElement(_caretRight.default, a11yHide);

exports.CARET_RIGHT = CARET_RIGHT;

var CARET_LEFT = _react.default.createElement(_caretLeft.default, a11yHide);

exports.CARET_LEFT = CARET_LEFT;

var CARET_DOWN = _react.default.createElement(_caretDown.default, a11yHide);

exports.CARET_DOWN = CARET_DOWN;

var CARET_UP = _react.default.createElement(_caretUp.default, a11yHide);

exports.CARET_UP = CARET_UP;

var VALID_ICON = _react.default.createElement(_check.default, a11yHide);

exports.VALID_ICON = VALID_ICON;

var SUCCESS_ICON = _react.default.createElement(_check.default, a11yHide);

exports.SUCCESS_ICON = SUCCESS_ICON;

var WARNING_ICON = _react.default.createElement(_exclamationTriangle.default, a11yHide);

exports.WARNING_ICON = WARNING_ICON;

var XICON = _react.default.createElement(_close.default, a11yHide);

exports.XICON = XICON;

var UNDO_ICON = _react.default.createElement(_replay.default, _extends({
  className: "icon-undo-rotate"
}, a11yHide));

exports.UNDO_ICON = UNDO_ICON;

var CALENDAR = _react.default.createElement(_calendar.default, a11yHide);

exports.CALENDAR = CALENDAR;

var CLOCK = _react.default.createElement(_clockO.default, a11yHide);

exports.CLOCK = CLOCK;

var PLUS = _react.default.createElement(_plus.default, a11yHide);

exports.PLUS = PLUS;

var MINUS = _react.default.createElement(_minus.default, a11yHide);

exports.MINUS = MINUS;

var INFO_ICON = _react.default.createElement(_exclamationCircle.default, a11yHide);

exports.INFO_ICON = INFO_ICON;

var PLUS_LIGHT = _react.default.createElement(_plus2.default, a11yHide);

exports.PLUS_LIGHT = PLUS_LIGHT;

var MINUS_LIGHT = _react.default.createElement(_minus2.default, a11yHide);

exports.MINUS_LIGHT = MINUS_LIGHT;

var CREDITCARD_ICON = _react.default.createElement(_creditCard.default, a11yHide);

exports.CREDITCARD_ICON = CREDITCARD_ICON;

var PAYPAL_ICON = _react.default.createElement(_paypal.default, a11yHide);

exports.PAYPAL_ICON = PAYPAL_ICON;

var APPLEPAY_ICON = _react.default.createElement(_apple.default, a11yHide);

exports.APPLEPAY_ICON = APPLEPAY_ICON;

var MASTERCARD_ICON = _react.default.createElement(_ccMastercard.default, a11yHide);

exports.MASTERCARD_ICON = MASTERCARD_ICON;

var TAG_ICON = _react.default.createElement(_TagIcon.TagIcon, a11yHide);

exports.TAG_ICON = TAG_ICON;

var SHIPPING_ICON = _react.default.createElement(_nudgeIcon.ShippingIcon, a11yHide);

exports.SHIPPING_ICON = SHIPPING_ICON;

var DISCOUNT_ICON = _react.default.createElement(_nudgeIcon.DiscountIcon, a11yHide);

exports.DISCOUNT_ICON = DISCOUNT_ICON;

var COMBINATION_OFFER_ICON = _react.default.createElement(_nudgeIcon.CombinationOfferIcon, a11yHide);

exports.COMBINATION_OFFER_ICON = COMBINATION_OFFER_ICON;

var GOGO_ICON = _react.default.createElement(_nudgeIcon.GoGoIcon, a11yHide);

exports.GOGO_ICON = GOGO_ICON;
var icons = {
  ERROR: ERROR,
  VALID: VALID,
  WARNING: WARNING,
  CART_ICON: CART_ICON,
  CHEVRON_DOWN: CHEVRON_DOWN,
  CHEVRON_UP: CHEVRON_UP,
  CHEVRON_LEFT: CHEVRON_LEFT,
  LARGE_CHEVRON_LEFT: LARGE_CHEVRON_LEFT,
  CHEVRON_RIGHT: CHEVRON_RIGHT,
  LARGE_CHEVRON_RIGHT: LARGE_CHEVRON_RIGHT,
  KEYBOARD_RIGHT: KEYBOARD_RIGHT,
  ADD_PHOTO: ADD_PHOTO,
  CHECK_SELECTED: CHECK_SELECTED,
  CIRCLE_EMPTY_ICON: CIRCLE_EMPTY_ICON,
  CARET_RIGHT: CARET_RIGHT,
  CARET_LEFT: CARET_LEFT,
  CARET_DOWN: CARET_DOWN,
  CARET_UP: CARET_UP,
  ERROR_ICON: ERROR_ICON,
  VALID_ICON: VALID_ICON,
  WARNING_ICON: WARNING_ICON,
  XICON: XICON,
  UNDO_ICON: UNDO_ICON,
  CALENDAR: CALENDAR,
  CLOCK: CLOCK,
  PLUS: PLUS,
  MINUS: MINUS,
  PLUS_LIGHT: PLUS_LIGHT,
  MINUS_LIGHT: MINUS_LIGHT,
  SUCCESS_ICON: SUCCESS_ICON,
  SUCCESS: SUCCESS,
  INFO_ICON: INFO_ICON,
  INFO: INFO,
  CREDITCARD: CREDITCARD,
  CREDITCARD_ICON: CREDITCARD_ICON,
  PAYPAL: PAYPAL,
  PAYPAL_ICON: PAYPAL_ICON,
  APPLEPAY: APPLEPAY,
  APPLEPAY_ICON: APPLEPAY_ICON,
  MASTERPASS: MASTERPASS,
  MASTERCARD_ICON: MASTERCARD_ICON,
  TAG: TAG,
  TAG_ICON: TAG_ICON,
  SHIPPING_ICON: SHIPPING_ICON,
  DISCOUNT_ICON: DISCOUNT_ICON,
  COMBINATION_OFFER_ICON: COMBINATION_OFFER_ICON,
  GOGO_ICON: GOGO_ICON
};
exports.icons = icons;